import { useTypedSelector } from '@Features/store';

export const useUnitPermissions = () => {
	const { permissions, user } = useTypedSelector((state) => state.auth);
	const isSuper = user?.type === 'super';
	return {
		canCreate: isSuper || permissions.has('c-unt'),
		canView: isSuper || permissions.has('v-unt'),
		canUpdate: isSuper || permissions.has('u-unt'),
		canDelete: isSuper || permissions.has('d-unt'),
	};
};

export default useUnitPermissions;
